/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_OkInputs */

const en_mk_tut_chat_ok = /** @type {(inputs: Mk_Tut_Chat_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent’s reply appears under your message with a thread marker and a reply count.`)
};

const id_mk_tut_chat_ok = /** @type {(inputs: Mk_Tut_Chat_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muncul balasan agen di bawah pesan Anda dengan penanda thread dan jumlah balasan.`)
};

/**
* | output |
* | --- |
* | "The agent’s reply appears under your message with a thread marker and a reply count." |
*
* @param {Mk_Tut_Chat_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_ok = /** @type {((inputs?: Mk_Tut_Chat_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_ok(inputs)
	return en_mk_tut_chat_ok(inputs)
});